import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { Button, Col, Dropdown, Row, Tooltip, Modal } from "antd";
import { UserOutlined } from "@ant-design/icons";

const ProfileIcons = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(["apiKey", "role"]);

  const navigate = useNavigate();

  const handleLogout = () => {
    removeCookie("apiKey", { path: "/" });
    navigate("/");
  };

  const confirmLogout = () => {
    handleLogout();
    setIsModalVisible(false);
  };

  const cancelLogout = () => {
    setIsModalVisible(false);
  };

  const items = [
    {
      key: "1",
      label: (
        <p
          className="ghaith--item-dropdown"
          onClick={() => setIsModalVisible(true)}
        >
          تسجيل الخروج
        </p>
      ),
    },
  ];

  return (
    <div className="ghaith--navbar-profile-icons">
      <Dropdown
        menu={{ items }}
        placement="bottom"
        overlayStyle={{ direction: "rtl", padding: "0 1rem 0 1rem" }}
      >
        <div className="ghaith--navbar-profile-icon">
          <UserOutlined />
        </div>
      </Dropdown>

      <Modal
        title=""
        open={isModalVisible}
        onCancel={cancelLogout}
        footer={null}
        centered
      >
        <Row justify="center">
          <p className="ghaith--confirm-logout">
            هل أنت متأكد أنك تريد تسجيل الخروج؟
          </p>
        </Row>
        <Row gutter={16} justify="center" style={{ paddingTop: "2rem" }}>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <Button
              className="ghaith--cancel-btn-logout"
              onClick={cancelLogout}
            >
              لا
            </Button>
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <Button
              className="ghaith--primary-button ghaith--confirm-btn-logout"
              onClick={confirmLogout}
            >
              نعم
            </Button>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default ProfileIcons;
